var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"40","cy":"40","r":"40","fill":"#2F9E42","fillOpacity":"0.08","key":0}),React.createElement("circle",{"cx":"40","cy":"40","r":"16","fill":"#2F9E42","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M47 36.2116L38.0107 45.2L33 40.1898L34.4117 38.7782L38.0107 42.3769L45.5883 34.8L47 36.2116Z","fill":"white","key":2})]);
}

InlineSvg.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
